import { Wrench, Newspaper, Inbox, TrendingUp, MessageSquareQuote } from 'lucide-react';
import { useFetch } from '../../hooks/useFetch';
import client from '../../api/client';
import { IconBadge } from '../../components/ui/IconBadge';

const STATS = [
  { key: 'services_actifs', label: 'Services actifs', icon: Wrench },
  { key: 'articles_publies', label: 'Articles publiés', icon: Newspaper },
  { key: 'demandes_nouvelles', label: 'Nouvelles demandes', icon: Inbox },
  { key: 'demandes_total_30j', label: 'Demandes (30 derniers jours)', icon: TrendingUp },
  { key: 'temoignages_a_valider', label: 'Témoignages à valider', icon: MessageSquareQuote },
];

export function Dashboard() {
  const { data, loading } = useFetch(() => client.get('/admin/dashboard'), []);

  if (loading) return <p>Chargement...</p>;

  return (
    <section>
      <h1>Tableau de bord</h1>

      <div className="admin-stats">
        {STATS.map((s) => (
          <div className="admin-stat-card" key={s.key}>
            <IconBadge icon={s.icon} tone="primary" />
            <div>
              <span className="admin-stat-card__value">{data?.stats?.[s.key] ?? '—'}</span>
              <span className="admin-stat-card__label">{s.label}</span>
            </div>
          </div>
        ))}
      </div>

      <h2>Dernières demandes</h2>
      <div className="admin-panel">
        {!data?.dernieres_demandes?.length && <p>Aucune demande récente.</p>}
        <ul className="admin-list">
          {data?.dernieres_demandes?.map((demande) => (
            <li key={demande.id}>
              {demande.formulaire} — {demande.statut} — {demande.created_at}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
